import { addWysiwygAudioModalActionTypes } from './Constants';

export function handleAddAudioModal(data) {
	return {
		type: addWysiwygAudioModalActionTypes.HANDLE_ADD_WYSIWYG_AUDIO_MODAL,
		payload: {
			data,
		},
	};
}

export function uploadAudio(data) {
	return {
		type: addWysiwygAudioModalActionTypes.UPLOAD_WYSIWYG_AUDIO_REQUEST,
		payload: { data },
	};
}

export function uploadAudioSuccess() {
	return {
		type: addWysiwygAudioModalActionTypes.UPLOAD_WYSIWYG_AUDIO_SUCCESS,
	};
}

export function uploadAudioError() {
	return {
		type: addWysiwygAudioModalActionTypes.UPLOAD_WYSIWYG_AUDIO_ERROR,
	};
}

export function clearState() {
	return {
		type: addWysiwygAudioModalActionTypes.CLEAR_WYSIWYG_AUDIO_STATE,
	};
}
